export default __webpack_public_path__ + "static/media/Bolo-De-Marble.cfd39020.jpg";